import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/icons.css";
import "../../assets/css/style.css";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow, LICENSE } from "../../Server";
import axios from "axios";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import CreateWorkflow from "./CreateWorkFlow";
import { CloseIcon, DeleteIcon, EditIcon, HomeIcon } from "../../assets/Icons";
import FilterBtn from "./FilterBtn";
import Search from "../../common/Search";
import { formatDateAndTime } from "../../common/common";
import NoDataFound from "../../common/NoDataFound";
import { connect } from "react-redux";
import HeaderMobile from "../../common/HeaderMobile";
import HeaderMobileSearch from "../../common/HeaderMobileSearch";
import WorkflowMoblie from "./WorkflowMoblie";
import AssignedWorkflowSkelton from "../../skeltonloader/TableSkelton";
import TableSkelton from "../../skeltonloader/TableSkelton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ShareModal from "../../common/ShareModal";
import { Tooltip, OverlayTrigger } from "react-bootstrap";

let statusFilter = {
  name: "Status",
  tags: [
    { key: 1, name: "Active", value: 1, type: "status" },
    { key: 0, name: "Inactive", value: 0, type: "status" },
  ],
};

const filterWorkflow = (completeList, filtersList, search) => {
  let sopIds = filtersList.filter((e) => e.type === "sop").map((f) => f.key);
  let statusKeys = filtersList.filter((e) => e.type === "status").map((f) => f.key);
  return completeList.filter((item) => {
    if (sopIds.length && !sopIds.includes(item.sop_id)) return false;
    if (statusKeys.length && !statusKeys.includes(item.versionData?.sort((a, b) => b.id - a.id)?.[0]?.is_published))
      return false;
    if (search && !item.title.toLowerCase().includes(search.toLowerCase())) return false;
    return item;
  });
};

class ListWorkflow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      creatingWorkflow: false,
      allWorkFlow: [],
      message: "",
      search: "",
      selectedCheckboxes: [],
      filterData: [],
      loading: true,
      showModal: false,
      selectedWorkflow: null,
      SOPList: []
    };
  }

  getSopList = () => {
    var data = {
      groupId  :this.props.userDetails?.user?.group?.uuid
    };
    let _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/SOP/SOPList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          if (response.data.SOP) {
            let workFlowTypeFilter = {
              name: "workflow type",
              tags: response.data.SOP.map((item) => ({
                key: item.id,
                name: item.sop_type_name,
                value: item.id,
                type: "sop",
              })),
            };
            _this.setState({ filterData: [statusFilter, workFlowTypeFilter] });
            _this.setState({ SOPList: response.data.SOP });
          }
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.getSopList();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  componentDidMount() {
    // if(sessionStorage.getItem('selected_workflow') == null || sessionStorage.getItem('selected_workflow') == undefined || sessionStorage.getItem('selected_workflow') ===""){
    //     // window.location.href = '/create/workflow'
    //     return
    // }
    if (this.props.userDetails?.token) {
      this.getSopList();
      this.getTotalType();
      this.dataByLicense();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.userDetails !== this.props.userDetails && this.props.userDetails) {
      this.getSopList();
      this.getTotalType();
      this.dataByLicense();
    }
  }

  dataByLicense = () => {
    if (LICENSE.workflow) {
      if (Object.keys(LICENSE.workflow).length == 0) {
        // window.location.href = "/dashboard";
        this.props.history.push("/dashboard");
      }
    } else {
      setTimeout(() => {
        this.dataByLicense();
      }, 1000);
    }
  };
  getTotalType = () => {
    let _this = this;

    _this.setState({
      loading: true,
    });

    var data = {
      jwt: jwt,
      sid: ud.main_id,
      user_UUID: this.props.userDetails?.user?.uuid,
      group_UUID: this.props.userDetails?.user?.group?.uuid,
    };
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/Workflow/workflows`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          if (response.data.workflow) {
            _this.setState({
              allWorkFlow: response.data.workflow,
              message: response.data.workflow.length === 0 ? "No Record Found." : "",
            });
          }
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.getTotalType();
            }
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {
        _this.setState({
          loading: false,
        });
      });
  };
  onChangeInput = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };
  handleImageChange = (e) => {
    e.preventDefault();
    if (!e.target.files[0]) {
      return;
    }
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      this.setState({
        logo: reader.result,
      });
    };
  };
  createWorkflow = () => {
    this.setState({ creatingWorkflow: true });
  };
  handleCloseWorkflow = () => {
    this.setState({ creatingWorkflow: false });
  };
  taskManageVersion = (list) => {
    // window.location.href = "/create/workflowversionlist";
    sessionStorage.setItem("selected_workflow", list.id);
    sessionStorage.setItem("selected_workflow_description", JSON.stringify(list));
    this.props.history.push("/create/workflowversionlist");
  };
  onSearch = (e) => {
    const searchValue = e.target.value;
    this.setState((prev) => ({ ...prev, search: searchValue }));
  };

  handleCheckboxChange = (item) => {
    this.setState((prev) => {
      const exists = prev.selectedCheckboxes.find((i) => i.key === item.key);
      if (exists) {
        return { ...prev, selectedCheckboxes: prev.selectedCheckboxes.filter((i) => i.key !== item.key) };
      } else {
        return { ...prev, selectedCheckboxes: [...prev.selectedCheckboxes, item] };
      }
    });
  };

  handleReset = () => {
    this.setState((prev) => ({ ...prev, selectedCheckboxes: [] }));
  };

  render() {
    const { errors, search, allWorkFlow, selectedCheckboxes, loading, showModal } = this.state;
    const workflowsToShow = filterWorkflow(allWorkFlow || [], selectedCheckboxes || [], search);
    const { user } = this.props;
    const { isMobile } = user;
    const { userDetails } = this.props;
    const { subGroups } = this.props;
    return (
      <>
        {!isMobile ? (
          <>
            <div className="xp-breadcrumbbar">
              <div className="xp-page-title">
                <h3 className="xp-page-title">Workflow Builder</h3>
              </div>
              <div className="row">
                <div className="col-md-9 col-lg-9">
                  <div className="xp-breadcrumb gradient-border">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <a onClick={() => this.props.history.push("/dashboard")}>
                          <i>
                            <HomeIcon />
                          </i>
                        </a>
                      </li>
                      <li className="breadcrumb-item active">Workflow Management</li>
                    </ol>
                  </div>
                </div>
                <div className="col-md-3 col-lg-3 filter-tab">
                  <Search onChange={this.onSearch} value={search} placeholder="Search..." />
                  <FilterBtn
                    selectedCheckboxes={this.state.selectedCheckboxes}
                    handleReset={this.handleReset}
                    handleCheckboxChange={this.handleCheckboxChange}
                    filterOptions={this.state.filterData}
                  />
                </div>
              </div>
            </div>
            <div className="xp-contentbar p-30 pt-3">
              <div className="row">
                <div className="col-lg-12 xp-content">
                  <div className="card m-b-30 document_gradient_border padding-0 border-before-15">
                    <div className="card-header dv-center space-between">
                      <h5 className="card-title text-black mb-0">Workflow Table</h5>
                      <button
                        className="btn btn-white btn-lg rounded"
                        title="create workflow"
                        onClick={this.createWorkflow}
                      >
                        <i className="mdi mdi-plus"></i> Create New
                      </button>
                    </div>
                    <div className="card-body ">
                      <div className="table-responsive">
                        <table className="table table-striped table-bordered">
                          <thead>
                            <tr>
                              <th className="text-center" style={{ width: "5%" }}>
                                S.No
                              </th>
                              <th style={{ width: "18%" }}>Title</th>
                              <th>Description</th>
                              <th>Workflow type</th>
                              <th>Date</th>
                              <th>Status</th>
                              <th>Version</th>
                              <th className="text-center">Manage</th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading ? (
                              <TableSkelton rowCount={3} colCount={8} />
                            ) : workflowsToShow.length == 0 ? (
                              <>
                                <tr>
                                  <td colSpan="8" className="text-center message-no-record">
                                    <NoDataFound headText={this.state.message} />
                                  </td>
                                </tr>
                              </>
                            ) : (
                              workflowsToShow.map((list, index) => (
                                <tr>
                                  <td className="text-center">
                                    <strong>{index + 1}.</strong>
                                  </td>
                                  <td>{list.title}</td>
                                  <td>{list.description}</td>
                                  <td>{list?.sopData?.sop_type_name || ""} </td>
                                  <td>
                                    <span className="pr-2">{formatDateAndTime(list.created_at)}</span>
                                  </td>
                                  <td>
                                    {list.versionData?.sort((a, b) => b.id - a.id)?.[0]?.is_published ? (
                                      <span className="text-success">Live</span>
                                    ) : (
                                      <span className="text-danger">Inactive</span>
                                    )}
                                  </td>
                                  <td>
                                    <span className="text-danger">
                                      {list.versionData?.sort((a, b) => b.id - a.id)?.[0]?.version || ""}
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <div
                                      className="tabledit-toolbar btn-toolbar"
                                      style={{ margin: "0 auto", display: "block" }}
                                    >
                                      <div className="sop-svg gap-4 d-flex">
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={<Tooltip id="tooltip-view">View SOP</Tooltip>}
                                        >
                                          <span
                                            className="sop-svg-icon"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => this.taskManageVersion(list)}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              viewBox="0 0 576 512"
                                              fill="#2f3a79"
                                            >
                                              <path d="M572.5 241.4C518.3 135.6 410.9 64 288 64S57.7 135.6 3.5 241.4a32.4 32.4 0 0 0 0 29.2C57.7 376.4 165.1 448 288 448s230.3-71.6 284.5-177.4a32.4 32.4 0 0 0 0-29.2zM288 400a144 144 0 1 1 144-144 143.9 143.9 0 0 1 -144 144zm0-240a95.3 95.3 0 0 0 -25.3 3.8 47.9 47.9 0 0 1 -66.9 66.9A95.8 95.8 0 1 0 288 160z" />
                                            </svg>
                                          </span>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                          placement="top"
                                          overlay={<Tooltip id="tooltip-share">Share</Tooltip>}
                                        >
                                          <span
                                            className="sop-svg-icon2"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => this.setState({ showModal: true, selectedWorkflow: list })}
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="17"
                                              height="17"
                                              fill="#2f3a79"
                                              className="bi bi-share-fill"
                                              viewBox="0 0 16 16"
                                            >
                                              <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5"></path>
                                            </svg>
                                          </span>
                                        </OverlayTrigger>
                                      </div>
                                    </div>

                                    {/* <div
                                      className="tabledit-toolbar btn-toolbar"
                                      style={{ margin: "0 auto", display: "block" }}
                                    >
                                      <div className="btn-group btn-group-sm">
                                        <button
                                          type="button"
                                          onClick={() => this.taskManageVersion(list)}
                                          className=" btn btn-info"
                                        >
                                        Share
                                        </button>
                                      </div>
                                    </div> */}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.state.creatingWorkflow && (
              <div
                className="modal show d-block"
                tabIndex="-1"
                role="dialog"
                style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
              >
                <div className="modal-dialog modal-dialog-scrollable" role="document">
                  <div className="modal-content">
                    <div className="modal-header d-flex justify-content-between">
                      <h5 className="modal-title mt-0">Create Workflow</h5>
                      <button
                        type="button"
                        className="close-s"
                        onClick={() => this.setState({ creatingWorkflow: false })}
                        aria-label="Close"
                      >
                        <span aria-hidden="true">
                          <CloseIcon />
                        </span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <CreateWorkflow userDetails={userDetails} getWorkflowList={this.getTotalType} SOPList={this.state.SOPList} getSopList={this.getSopList} handleCloseWorkflow={this.handleCloseWorkflow} />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {/* <HeaderMobile  /> */}
            <WorkflowMoblie workflows={this.state.allWorkFlow} taskManageVersion={this.taskManageVersion} />
          </>
        )}

        <ShareModal
          show={this.state.showModal}
          onClose={() => this.setState({ showModal: false })}
          subGroups={subGroups}
          userDetails={userDetails}
          selectedWorkflow={this.state.selectedWorkflow}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.userData,
  userDetails: state.userData.userDetails,
  subGroups: state.userData.subGroups,
});

// export default ListWorkflow;
export default withRouter(connect(mapStateToProps)(ListWorkflow));

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);
const validateForm = (errors) => {
  let valid = true;
  Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
  return valid;
};
